"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Image = _interopRequireDefault(require("../../atoms/Image"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _Spin = _interopRequireDefault(require("../../atoms/Spin"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _ts = require("../../ts");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  image: '',
  loadingOnDelete: false,
  loadingOnSubmit: false,
  helperTexts: [],
  buttonText: '',
  onDelete() {},
  onLoad() {}
};
function ImageDisplay(props) {
  const {
    image,
    size,
    onDelete,
    onLoad,
    loadingOnDelete,
    loadingOnSubmit,
    buttonText,
    helperTexts,
    shape
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const helpersStyles = (0, _react.useMemo)(() => cssHelpersStyles(size), [size]);
  const handleOnDelete = (0, _react.useCallback)(() => {
    if (loadingOnDelete) return;
    onDelete === null || onDelete === void 0 || onDelete();
  }, [loadingOnDelete, onDelete]);
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(ContainerImage, null, /*#__PURE__*/_react.default.createElement(DeleteIconContainer, {
    onClick: handleOnDelete
  }, loadingOnDelete ? /*#__PURE__*/_react.default.createElement(_Spin.default, {
    size: 10,
    type: "white"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "delete_forever",
    size: 10,
    color: "white"
  })), /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image,
    width: size === null || size === void 0 ? void 0 : size.width,
    height: size === null || size === void 0 ? void 0 : size.height,
    fit: "cover",
    rounded: shape === _ts.UIElementShapeEnum.Rect ? 10 : size.width
  })), /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 25,
    styles: helpersStyles
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "white",
    outlined: true,
    width: "".concat(size.width, "px"),
    size: _ts.UIElementSizesEnum.Medium,
    onClick: onLoad,
    loading: loadingOnSubmit,
    disabled: loadingOnSubmit,
    children: buttonText
  }), /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 10
  }, helperTexts === null || helperTexts === void 0 ? void 0 : helperTexts.map((helperText, index) => /*#__PURE__*/_react.default.createElement(_Typography.default, {
    key: index,
    type: "helper",
    color: "white",
    align: "center",
    children: helperText
  })))));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
const ContainerImage = _styled.default.figure(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 50px;\n"])));
const DeleteIconContainer = _styled.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 23px;\n  height: 23px;\n  ", "\n  border-radius: 23px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  cursor: pointer;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return "background-color: ".concat(theme.colors.MAIN.ERROR, ";");
});
const cssHelpersStyles = size => (0, _react2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n"])), size === null || size === void 0 ? void 0 : size.width);
var _default = exports.default = ImageDisplay;